import { ErrorString, InvalidOperationException } from "../../shared/index.js";
export const maxAsync = async (source, selector) => {
    let max = null;
    for await (const item of source) {
        max = Math.max(max ?? Number.NEGATIVE_INFINITY, await selector(item));
    }
    if (max === null) {
        throw new InvalidOperationException(ErrorString.NoElements);
    }
    else {
        return max;
    }
};
